import { ComponentProps } from "react";
import CompetitionCardFooter from "../components/CompetitionDetails/CompetitionCardFooter";
import {
  PageContext,
  isCompetitionPageContext,
} from "../hooks/useDetailsPageContext";
import EventCTACard from "../components/events.EventCTACard";
import { CTACountdownProps } from "../components/events.CTACard";

const competitionCTACardProps = (pageContext: PageContext) => {
  if (!isCompetitionPageContext(pageContext)) {
    return {};
  }

  return {
    title: pageContext.competition?.title,
    image: pageContext.competition?.prizes?.[0].image,
    imageAlt: pageContext.competition?.title,
    footer: (
      <CompetitionCardFooter
        competition={pageContext.competition}
        venue={pageContext.event?.venue}
      />
    ),
  };
};

interface EventCTAState {
  ctaTitle: string | null;
  competitionCTACardProps: ComponentProps<typeof EventCTACard>;
  countdownTo?: CTACountdownProps["countdownTo"];
}

const eventCTATitle = (pageContext: PageContext) => {
  switch (pageContext.state) {
    case "info":
      return "The countdown is on!";
    case "registration":
    case "registration-presale":
      return "Be the first to know when tickets go live!";
    case "active-presale":
      return "Presale is now live!";
    case "onsale":
      return "Secure your tickets today!";
    case "registration-presale-pre-purchase":
      return "Be first in line for tickets!";
    case "registration-competition":
    case "registration-presale-competition":
    case "onsale-competition":
      return pageContext.competition?.title;
  }
};

export const ctaStateFromPageContext = (
  pageContext: PageContext
): EventCTAState => {
  const presaleStartTime = pageContext.event?.presaleRelease?.startConditionDate
    ? new Date(pageContext.event?.presaleRelease?.startConditionDate)
    : null;

  const mainSaleStartTime = pageContext.event?.publicReleaseStartsAt
    ? new Date(pageContext.event.publicReleaseStartsAt)
    : null;

  let countdownTo: EventCTAState["countdownTo"] | undefined =
    mainSaleStartTime &&
    (pageContext.state === "active-presale" ||
      pageContext.state === "registration" ||
      pageContext.state === "registration-competition" ||
      pageContext.state === "info")
      ? {
          type: "onsale",
          date: mainSaleStartTime,
          label: "Public sale starts:",
        }
      : undefined;

  if (
    presaleStartTime &&
    (pageContext.state === "registration-presale" ||
      pageContext.state === "registration-presale-competition" ||
      pageContext.state === "registration-presale-pre-purchase")
  ) {
    countdownTo = {
      type: "presale",
      date: presaleStartTime,
      label: "Presale starts:",
    };
  }

  return {
    ctaTitle: eventCTATitle(pageContext),
    countdownTo,
    competitionCTACardProps: competitionCTACardProps(pageContext),
  };
};
